import ProfileEditModal from './ProfileEditModal';

export default ProfileEditModal;
